import moment from 'moment'
const moneyFilters = val => {
  let num = (val || 0).toString()
  let result = ''
  let tempNum = num.indexOf('.') > 0 ? num.substr(0, num.indexOf('.')) : num
  let decimals = num.indexOf('.') > 0 ? num.substr(num.indexOf('.')) : ''
  if (decimals.length === 2) {
    decimals += '0'
  }
  while (tempNum.length > 3) {
    result = ',' + tempNum.slice(-3) + result
    tempNum = tempNum.slice(0, tempNum.length - 3)
  }
  if (tempNum) {
    result = tempNum + result + decimals
  }
  return result
}

const productAttrFilters = res => {
  if (res) {
    try {
      // 如果JSON.parse转过之后还是字符串，就再处理一次
      if (typeof JSON.parse(res) === 'string') {
        let data = JSON.parse(res).split(',')
        return data.join(',')
      } else {
        return JSON.parse(res).join(',') || JSON.parse(res) || ''
      }
    } catch (e) {
      return res
    }
  } else {
    return ''
  }
}

const couponType = val => {
  if (val == 0) {
    return '全场'
  } else if (val == 1) {
    return '类目'
  } else if (val == 2) {
    return '商品'
  } else {
    return '满减'
  }
}

const logisticsStatus = val => {
  let index = Math.floor(val)
  switch (index) {
    case 0:
      return '运输中'
    case 1:
      return '快递员已揽收'
    case 3:
      return '买家已签收'
    case 5:
      return '派件中'
    default:
      return ''
  }
}

const timeDate = val => {
  return moment(val).format('YYYY-MM-DD')
}

const formatDate = val => {
  return moment(val).format('YYYY-MM-DD HH:mm:ss')
}

const orderStatusFilters = value => {
  // 订单状态：1->待付款；2->待发货；3->待收货；4->退款中；5->已退款；6->已取消；7->已完成；8->已删除
  if (value == 1) {
    return '待付款'
  } else if (value == 2) {
    return '待发货'
  } else if (value == 3) {
    return '待收货'
  } else if (value == 4) {
    return '退款中'
  } else if (value == 5) {
    return '已退款'
  } else if (value == 6) {
    return '已取消'
  } else if (value == 7) {
    return '已完成'
  } else if (value == 8) {
    return '已删除'
  } else if (value == 10) {
    return '已关闭'
  } else if (value == 11) {
    return '已发货'
  } else if (value == 12) {
    return '已收货'
  } else if (value == 13) {
    return '售后申请中'
  } else if (value == 14) {
    return '售后申请完成'
  }
}

const payStatusFilters = value => {
  // 付款状态：1->未付款；2->已付款
  if (value == 1) {
    return '未支付'
  } else if (value == 2) {
    return '已支付'
  }
}

const payType = val => {
  // 支付方式
  if (val === 1) {
    return '微信'
  } else if (val === 2) {
    return '支付宝'
  } else if (val === 3) {
    return '网银'
  } else {
    return '未支付'
  }
}

// 订单状态：1->待付款；2->待发货；3->销售出库；4->申请退货退款；5->申请换货；6->退货已入库；7->换货已入库；8->换货已出库 9->退款中 10 ->退款完成 11->交易完成 13 填写单号
const productStatusFilters = res => {
  switch (res) {
    case 1:
      return '待付款'
    case 2:
      return '待发货'
    case 3:
      return '销售出库'
    case 4:
      return '申请退货退款'
    case 5:
      return '申请换货中'
    case 6:
      return '退货已入库中'
    case 7:
      return '换货已入库中'
    case 8:
      return '换货已出库中'
    case 9:
      return '退款中'
    case 10:
      return '退款完成'
    case 11:
      return '交易完成'
    case 14:
      return '拒绝退换货'
    case 15:
      return '已关闭'
    case 16:
      return '已发货'
    case 17:
      return '已收货'
    case 18:
      return '申请退货退款中'
    case 19:
      return '申请换货中'
    case 20:
      return '申请退款中'
    case 21:
      return '退货退款成功'
    case 22:
      return '换货成功'
    case 23:
      return '退款成功'
    case 24:
      return '拒绝退货退款'
    case 25:
      return '拒绝换货'
    case 26:
      return '拒绝退款'
    case 27:
      return '退货退款失败'
    case 28:
      return '换货失败'
    case 29:
      return '退款失败'
    case 30:
      return '售后申请已撤销'
    default:
      return '交易完成'
  }
}

export {
  moneyFilters,
  productAttrFilters,
  couponType,
  timeDate,
  formatDate,
  orderStatusFilters,
  payStatusFilters,
  logisticsStatus,
  payType,
  productStatusFilters
}



// WEBPACK FOOTER //
// ./src/assets/js/filter.js